import type { PermissionCheckRes } from '@/modules/Permission/type';
import { onePageRequest } from '@/services/request';

/**
 * 获取网站权益列表
 */
export function getPermissionCheck(projectId: string) {
  return onePageRequest.post<PermissionCheckRes>('/permission/check', {
    siteId: projectId,
  });
}
